module.exports = __webpack_public_path__ + "static/media/modelX_Mobile_BackgroundPic.ddfdeadd.jpg";